// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__DG4hM","container":"Header_container__5DPFW","logo":"Header_logo__Fm6tq","btn":"Header_btn__4JvvU"};